import { useEffect } from 'react';

const defaultOptions = {
  rootMargin: '400px 0px',
};

/**
 * @param {Array | Object} collection
 * @param {Function} onIntersection
 * @param {Object} options
 * @param {Boolean} alwaysObserve
 */
const useIntersectionObserver = (
  collection,
  onIntersection,
  options = defaultOptions,
  alwaysObserve = false,
) => {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

  useEffect(() => {
    const handleIntersect = (entries, observer) => {
      entries.map((entry) => {
        // TODO could this be made more straightforward?
        if (entry.isIntersecting) {
          onIntersection(entry);
          if (!alwaysObserve) {
            observer.unobserve(entry.target);
          }
        } else if (alwaysObserve) {
          onIntersection(entry);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, options);

    // If more than one element, it should be an array or nodelist
    if (collection.length > 1) {
      collection.forEach((el) => {
        observer.observe(el);
      });
    }

    // If only a single element it may be nodelist/array or a ref object
    if (collection.length === 1) {
      observer.observe(collection[0]);
    } else if (collection.current) {
      observer.observe(collection.current);
    }

    // If unmounting, then disconnect
    return () => {
      observer.disconnect();
    };
  }, [collection]);
};

export default useIntersectionObserver;
